module.exports = __webpack_public_path__ + "static/img/Derge-Parkhang-3.d54d5e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/DergeParkhang/Derge-Parkhang-3.jpg
// module id = tvpk
// module chunks = 3